import * as React from 'react';
import clsx from 'clsx';
import { useAuth } from 'contexts/authUser/store';
import { authUserSelectors } from 'contexts/authUser';
import Button from 'components/Button';
import { useTranslation } from 'next-i18next';
import { useCreditCardApplicationUrl } from 'hooks/useCreditCardApplicationUrl';
import Link from 'components/Link';
import analytics, { ANALYTIC_EVENTS } from 'utils/firebase/analytics';
import { routes } from 'utils/routes';
import { useLoyalty } from 'contexts/loyalty';
import { useRouter } from 'next/router';

interface Props {
  className?: string;
}

const CTAButton: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { userBalance } = useLoyalty();
  const { pathname } = useRouter();
  const { isLoggedIn } = useAuth(state => ({
    isLoggedIn: authUserSelectors.isLoggedIn(state)
  }));

  const creditCardApplicationUrl = useCreditCardApplicationUrl();

  const logApplicationClick = async () => {
    analytics.logEvent(ANALYTIC_EVENTS.CREDIT_CARD_APPLICATION_STARTED, { origin: pathname });
  };

  return (
    <div className={clsx('CTAButton', className)}>
      {!isLoggedIn ? (
        <Link
          href={{
            pathname: routes.auth.login(),
            query: { redirectTo: routes.poinz.poinzCards.index() }
          }}
          passHref
          legacyBehavior
        >
          <Button variant="primary" size="lg" onClick={logApplicationClick}>
            {t('general.applyForCard')}
          </Button>
        </Link>
      ) : (
        <Button
          variant="primary"
          size="lg"
          loading={!userBalance}
          href={creditCardApplicationUrl}
          target="_blank"
        >
          {t('loyalty.getTheCard')}
        </Button>
      )}
    </div>
  );
};

export default CTAButton;
